import { Box } from '@ghq-abi/design-system';
import { useSession } from '@ghq-abi/auth-client-lib/client';
import { useEffect } from 'react';
// eslint-disable-next-line import/no-cycle
import {
  EmptyState,
  FiltersBar,
  GridCard,
  ListCard,
  MyTicketsHeader,
  SkeletonGrid,
  SkeletonList,
  useMyTickets,
} from '~/app/components/MyTickets';
import { GRID_CONSTANTS } from '~/shared/constants';
import { handleShowByEvent } from '~/shared/components/MetricsCes/showByEvent';
import { getPersistedLanguage } from '~/shared/utils/languagePersistence';

export function MyTicketsContainer() {
  const { viewMode, tickets, isLoading } = useMyTickets();
  const { data: session } = useSession();

  useEffect(() => {
    if (session?.user?.globalId) {
      handleShowByEvent({
        globalId: session.user.globalId,
        language: getPersistedLanguage(),
      });
    }
  }, [session]);

  const renderContent = () => {
    if (isLoading) {
      return viewMode === 'grid' ? <SkeletonGrid /> : <SkeletonList />;
    }

    if (tickets.length === 0) {
      return <EmptyState />;
    }

    if (viewMode === 'grid') {
      return (
        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: GRID_CONSTANTS.GRID_TEMPLATE_COLUMNS,
            gap: '$4',
            mt: '$4',
          }}
        >
          {tickets.map(ticket => (
            <GridCard key={ticket.ticketNumber} ticket={ticket} />
          ))}
        </Box>
      );
    }

    return (
      <Box
        css={{
          mt: '$4',
          display: 'flex',
          flexDirection: 'column',
          gap: '$3',
        }}
      >
        {tickets.map(ticket => (
          <ListCard key={ticket.ticketNumber} ticket={ticket} />
        ))}
      </Box>
    );
  };

  return (
    <Box css={{ p: '$4' }}>
      <MyTicketsHeader />
      <FiltersBar />
      {renderContent()}
    </Box>
  );
}
